/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import barchart from "../../images/barchart.png";
import { Interweave } from "interweave";
import obliques from "../../images/obliques-m.PNG";
import ExerciseEducationalVideoModal from "../ExerciseEducationalVideoModal";
import { EXERCISE_TIMES } from "../../../utils/constants";
import { Button } from "react-bootstrap";
import { updateUserProgramDayExercise } from "../../../actions/user_program";
import { connect, useDispatch } from "react-redux";
import { getSkipReasons } from "../../../actions/user_test";
import SkipExerciseModal from "./SkipExerciseModal";
import StatusCheckoutModal from "../StatusCheckoutModal";
import Dropdown from "react-bootstrap/Dropdown";
import TestVideoPlayer from "./TestVideoPlayer";
import Modal from "react-bootstrap/Modal";
import { FaEdit, FaTimes } from "react-icons/fa";
import logo from "../../images/logo.png";
import { CommonPageData } from '../../../styles/common.style';


const Test1Week1 = ({
  showExercise,
  activeDay,
  program,
  nextExercise,
  setActiveExercise,
  updateUserProgramDayExercise,
  exerciseUpdateSuccess,
  getSkipReasons,
  skipTestReason,
  skipExerciseSuccess,
  setRepeatCircuit,
  filteredExercises,
  updateExercise,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [activeExerciseLevel, setActiveExerciseLevel] = useState(null);
  const [showEducationalModal, setShowEducationalModal] = useState(false);
  const [isCompleteDisable, setIsCompleteDisable] = useState(false);
  const [isStart, setIsStart] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [showExerciseSkipModal, setShowExerciseSkipModal] = useState(false);
  const [showStatusOutModal, setShowStatusOutModal] = useState(false);

  const [dumbbellsValue, setDumbbellsValue] = useState(0);
  const [timeValue, setTimeValue] = useState("");
  const [noteValue, setNoteValue] = useState("");
  const [rapsValue, setRapsValue] = useState(null);
  const [durationValue, setDurationValue] = useState("");
  const [startedValue, setStartedValue] = useState("");
  const [endedValue, setEndedValue] = useState("");

  const [seconds, setSeconds] = useState(0);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [error, setError] = useState("");

  const [errorDumbell, setErrorDumbell] = useState("");
  const [errorNote, setErrorNote] = useState("");

  const [countTime, setCountTime] = useState(0);
  const [showWeight, setShowWeight] = useState(false);
  const countDownRef = useRef();
  const dispatch = useDispatch();

  const [isEndExerciseConfirm, setIsEndExerciseConfirm] = useState(false);
  const [isEndExercise, setIsEndExercise] = useState(false);

  const handleShow = () => setShowEducationalModal(true);
  const handleClose = () => setShowEducationalModal(false);
  const handleCloseExerciseSkipModal = () => setShowExerciseSkipModal(false);
  const handleStatusOutModal = () => setShowStatusOutModal(false);
  const handleCloseWeight = () => setShowWeight(false);
  const handleEndExerciseConfirm = () => setIsEndExerciseConfirm(false);
  const handleEndExercise = () => setIsEndExercise(false);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  const [counter, setCounter] = useState(3);
  const [isCountTimerActive, setIsCountTimerActive] = useState(false);
  const [showCounter, setIsShowCounter] = useState(false);
  // const countDownRef = useRef();
  const [playing, setPlaying] = useState(false);
  const [selectedIntensity, setSelectedIntensity] = useState("");
  const [isIntensityMsg, setIsIntensityMsg] = useState(false);

  const [newWeigtValue, setNewWeightValue] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCloseExercise = () => setIsModalOpen(false);
  const [selectedSet, setSelectedSet] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(formatTime(seconds));
  const [isTimeChanged, setIsTimeChanged] = useState(false);
  //const [isNoteDisabled, setIsNoteDisabled] = useState(false);
  const [hasChangedKg, setHasChangedKg] = useState(false);
  const [hasChangedReps, setHasChangedReps] = useState(false);
  const [hasChangedTime, setHasChangedTime] = useState(false);


  const ScrollRef = useRef(null);

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "150px",
      height: "100px",
      backgroundColor: "#f0f0f0",
      borderRadius: "10px",
      padding: "10px",
    },
    input: {
      width: "60%",
      border: "none",
      borderBottom: "2px solid #000",
      textAlign: "center",
      fontSize: "28px",
      background: "transparent",
      outline: "none",
      height: "30px",
      color: "#D3D3D3",
      //color: "#000",
      fontWeight: "600",
    },
    label: {
      marginTop: "5px",
      fontSize: "14px",
      fontWeight: "bold",
      color: "#666",
    },
    button: {
      // backgroundColor: "#4CAF50",
      color: "white",
      border: "none",
      borderRadius: "10px",
      padding: "25px 20px",
      fontSize: "20px",
      cursor: "pointer",
      fontWeight: "bold",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      transition: "background-color 0.3s ease",
      height: "100px",
      width: "120px",
      textTransform: "uppercase",
    },
    buttonStart: {
      color: "#000",
      border: "1px solid red",
      borderRadius: "10px",
      cursor: "pointer",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      transition: "background-color 0.3s ease",
      height: "100px",
      width: "120px",
      textTransform: "uppercase",
      background: "#fff",
      fontWeight: "500",
    },
    buttonComplete: {
      color: "white",
      border: "none",
      borderRadius: "10px",
      padding: "25px 20px",
      fontSize: "20px",
      cursor: "pointer",
      fontWeight: "bold",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      transition: "background-color 0.3s ease",
      height: "100px",
      background: "#000",
      textTransform: "uppercase",
    },
    buttonNext: {
      color: "white",
      border: "none",
      borderRadius: "10px",
      padding: "25px 20px",
      fontSize: "20px",
      cursor: "pointer",
      fontWeight: "bold",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      transition: "background-color 0.3s ease",
      height: "100px",
      width: "120px",
      background: "#fb1417",
      textTransform: "uppercase",

    },
    buttonHover: {
      backgroundColor: "#45a049",
    },
    equipments: {
      fontWeight: "bold",
      fontSize: "16px",
    },
    notfound: {
      color: "red",
    },
    editIcon: {
      position: "absolute",
      right: "-30px", // Adjust distance from input
      cursor: "pointer",
      fontSize: "20px",
      color: "#333",
    },
  };

  const precisionLift = [
    {
      id: 1,
      difficulty: "Very Easy",
      weight_change: 7.5,
    },
    {
      id: 2,
      difficulty: "Easy",
      weight_change: 5,
    },
    {
      id: 3,
      difficulty: "Slightly Easy",
      weight_change: 2.5,
    },
    {
      id: 4,
      difficulty: "Somewhat Easy",
      weight_change: 1,
    },
    {
      id: 5,
      difficulty: "Moderate",
      weight_change: 0,
    },
    {
      id: 6,
      difficulty: "Somewhat Hard",
      weight_change: -1,
    },
    {
      id: 7,
      difficulty: "Slightly Hard",
      weight_change: -2.5,
    },
    {
      id: 8,
      difficulty: "Hard",
      weight_change: -5,
    },
    {
      id: 9,
      difficulty: "Very Hard",
      weight_change: -7.5,
    },
  ];

  const heavyLift = [
    {
      id: 1,
      difficulty: "Very Easy",
      weight_change: 20,
    },
    {
      id: 2,
      difficulty: "Easy",
      weight_change: 15,
    },
    {
      id: 3,
      difficulty: "Slightly Easy",
      weight_change: 10,
    },
    {
      id: 4,
      difficulty: "Somewhat Easy",
      weight_change: 5,
    },
    {
      id: 5,
      difficulty: "Moderate",
      weight_change: 0,
    },
    {
      id: 6,
      difficulty: "Somewhat Hard",
      weight_change: -5,
    },
    {
      id: 7,
      difficulty: "Slightly Hard",
      weight_change: -10,
    },
    {
      id: 8,
      difficulty: "Hard",
      weight_change: -15,
    },
    {
      id: 9,
      difficulty: "Very Hard",
      weight_change: -20,
    },
  ];

  useEffect(() => {
    // Update viewport width when the window is resized
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
    };
    // Attach the resize event listener
    window.addEventListener("resize", handleResize);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (showExercise) {
      setIsPaused(true);
      setIsTimerActive(false);
      setPlaying(false);

      setCountTime(showExercise.exerciseLevel.time * 60);

      setDumbbellsValue(
        showExercise.user_weight != 0
          ? showExercise.user_weight
          : showExercise.exerciseLevel.suggested_weight_lbs
      );


      setRapsValue(showExercise.exerciseLevel.metric == 10 ? showExercise.exerciseLevel.reps : "")


      setIsStart(true);
      setErrorDumbell("");
      setErrorNote("");
      setError("");
    }
  }, [showExercise]);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo({
      top: 0, // 100 pixels from the top
      behavior: "smooth", // Smooth scroll behavior
    });
  }, []);

  useEffect(() => {
    let interval = null;
    if (isTimerActive) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds + 1);
        setDurationValue(seconds + 1);
      }, 1000);
    } else if (!isTimerActive && seconds !== 0) {
      clearInterval(interval);
    }
    setEndedValue(new Date());
    return () => clearInterval(interval);
  }, [isTimerActive, seconds]);

  useEffect(() => {
    let interval = null;
    if (isCountTimerActive) {
      interval = setInterval(() => {
        setCounter(counter - 1);
        if (counter < 2) {
          setIsShowCounter(false);
          setSeconds(0);
          setStartedValue(new Date());
          setIsTimerActive(true);
          setIsStart(true);
          setIsCountTimerActive(false);
          setPlaying(true);
        }
      }, 1000);
    } else if (!isCountTimerActive && counter !== 0) {
      clearInterval(interval);
      setIsCountTimerActive(false);
      setIsShowCounter(false);
    }
    if (counter == 0) {
      setHasChangedTime(true);
    }

    setEndedValue(new Date());
    return () => clearInterval(interval);
  }, [isCountTimerActive, counter]);

  const handleStart = () => {
    setCounter(3);
    setIsCountTimerActive(true);
    setIsShowCounter(true);
    setIsTimeChanged(true)
  };

  const handlePause = () => {
    setIsPaused(true);
    setIsTimerActive(false);
    setPlaying(false);
  };

  const handleResume = () => {
    setIsPaused(false);
    setIsTimerActive(true);
    setPlaying(true);
  };

  useEffect(() => {
    if (!skipTestReason) {
      getSkipReasons();
    }
  }, []);

  const handleClick = (event) => {
    // 👇️ toggle isActive state on click
    setIsActive((current) => !current);
  };

  const CheckPosImage = (feelPos) => {
    if (feelPos === "TR") {
      return "top-right";
    } else if (feelPos === "TL") {
      return "top-left";
    } else if (feelPos === "BL") {
      return "bottom-left";
    } else if (feelPos === "BR") {
      return "bottom-right";
    } else {
      return "";
    }
  };

  const CheckPosText = (overlayPos) => {
    if (overlayPos === "TR") {
      return "top-right";
    } else if (overlayPos === "TL") {
      return "top-left";
    } else if (overlayPos === "BL") {
      return "bottom-left";
    } else if (overlayPos === "BR") {
      return "bottom-right";
    } else {
      return "";
    }
  };

  const checkOrientationText = (n) => {
    if (n == 1) {
      return "Left Side Only";
    } else if (n == 2) {
      return "Right Side Only";
    }
    else {
      return "";
    }
  };

  // Function for the "Done" button click
  const handleSubmit = async () => {
    let weightLbs = parseInt(dumbbellsValue);

    let dt = {
      filteredExercises: filteredExercises.length > 0 ? filteredExercises : [],
      user_weight: newWeigtValue,
      intensity_level: selectedIntensity,
      reps: rapsValue ? rapsValue : 0,
      user_program_day_exercise_id: showExercise.id,
      user_lbs: dumbbellsValue ? dumbbellsValue : 0,
      user_time: timeValue ? timeValue : "",
      start_at: startedValue ? startedValue : "",
      end_at: endedValue ? endedValue : "",
      note: noteValue ? noteValue : "",
      duration: durationValue ? durationValue : "",
      active_exercise_id: nextExercise ? nextExercise : showExercise.id,
      active_day_id: showExercise.user_program_day_id
        ? showExercise.user_program_day_id
        : "",
    };
    setIsTimerActive(false);
    setIsStart(false);
    setError("");
    setErrorDumbell("");
    setSeconds(0);
    setRapsValue(null);
    setDumbbellsValue(null);

    if (showExercise.userProgramDayExercisesAttempt.length < 3) {
      let res = await updateUserProgramDayExercise(dt, showExercise.id);

      setIsCompleteDisable(false);
      setNewWeightValue(0)
      setSelectedIntensity("")

      setShowWeight(false);
      setCounter(3);
      setIsCountTimerActive(false);
      setIsShowCounter(false);
    }


    window.scrollTo({
      top: 200,
      behavior: "smooth",
    });
  };

  useEffect(() => {
  }, [dumbbellsValue]);

  useEffect(() => {
    if (!showStatusOutModal) {
      setIsStart(true);
    } else {
      setIsStart(false);
    }
  }, [showStatusOutModal]);

  useEffect(() => {
    if (exerciseUpdateSuccess !== null && exerciseUpdateSuccess !== undefined) {
      dispatch({ type: "USER_PROGRAM_EXERCISE_UPDATE_PURGE" });
      setNoteValue("");

      if (nextExercise) {
        setActiveExerciseFunc(nextExercise);
      }
      if (nextExercise == null) setIsEndExerciseConfirm(true);
    }
  }, [exerciseUpdateSuccess, dispatch, nextExercise]);

  const handleCompleteExercise = () => {
    setIsStart(false);
    setShowExerciseSkipModal(false);
    setShowEducationalModal(false);
    setShowStatusOutModal(true);
    setIsEndExerciseConfirm(false)
    setIsEndExercise(true)
  };

  const handleRepeatCircuit = () => {
    setRepeatCircuit(true);
    setSeconds(0);
    setIsTimerActive(false);
  };

  const setActiveExerciseFunc = (data) => {
    setActiveExercise(data);
  };

  const setDumbbellsValueFunc = (e) => {
    setDumbbellsValue(e.target.value);
    setHasChangedKg(true);
    if (e.target.value.length > 5) {
      setErrorDumbell("Max length is 5");
      return;
    } else {
      setErrorDumbell("");
    }
  };

  const setTimeValueFunc = (e) => {
    setHasChangedTime(true);
    setTimeValue(e.target.value);
  };

  const setNoteValueFunc = (e) => {
    if (e.target.value.length > 500) {
      setErrorNote("Max length is 500");
      return;
    } else if (e.target.value.length == 0) {
      setNoteValue(e.target.value);
      if (rapsValue === null) {
        setIsCompleteDisable(false);
      }
    } else {
      setErrorNote("");
      setNoteValue(e.target.value);
      setIsCompleteDisable(true);
    }
  };

  const setRapsValueFunc = (e) => {
    setHasChangedReps(true);
    const parsedRepsValue = parseInt(e.target.value, 10);

    if (isNaN(parsedRepsValue)) {
      setError("Please enter a valid number of reps");
      setRapsValue(null);
      if (noteValue?.length === 0) {
        setIsCompleteDisable(false);
      }
      return;
    } else if (!parsedRepsValue || !Number.isInteger(parsedRepsValue)) {
      setRapsValue(null);
      setError("Please enter a valid number of reps");
      if (noteValue?.length === 0) {
        setIsCompleteDisable(false);
      }
      return;
    } else {
      setError("");
      setRapsValue(e.target.value);
      setIsCompleteDisable(true);
    }
  };

  const handleFinishNew = async () => {
    setIsPaused(true);
    setIsTimerActive(false);
    setPlaying(false);
  }

  const handleFinish = async () => {
    setPlaying(false);
    setIsPaused(false);

    if (error || errorDumbell || errorNote) {
      return;
    }
    let parsedRepsValue = parseInt(rapsValue, 10);

    if (
      showExercise.exerciseLevel.metric == 10 &&
      (!parsedRepsValue ||
        !Number.isInteger(parsedRepsValue) ||
        parsedRepsValue == "")
    ) {

      setError("Please enter a valid number of reps");
      return;
    }
    if (
      showExercise.exerciseLevel.reps &&
      showExercise.exerciseLevel.metric == 20 &&
      !timeValue
    ) {

      setError("Please enter the time.");
      return;
    }
    if (
      showExercise.exerciseLevel.suggested_weight_lbs &&
      (dumbbellsValue == null || dumbbellsValue == "")
    ) {

      setErrorDumbell("Please enter the weight.");
      return;
    }

    if (
      showExercise.exerciseLevel.metric == 10 &&
      dumbbellsValue &&
      rapsValue
    ) {
      setShowWeight(true);
    }

    let dt = {
      reps: rapsValue ? rapsValue : 0,
      user_program_day_exercise_id: showExercise.id,
      user_lbs: dumbbellsValue ? dumbbellsValue : 0,
      user_time: timeValue ? timeValue : '',
      start_at: startedValue ? startedValue : '',
      end_at: endedValue ? endedValue : '',
      note: noteValue ? noteValue : '',
      duration: durationValue ? durationValue : '',
      active_exercise_id: nextExercise ? nextExercise : showExercise.id,
      active_day_id: showExercise.user_program_day_id ? showExercise.user_program_day_id : ''
    }

    setError('');
    setErrorDumbell('')
    setSeconds(0);
    setIsCompleteDisable(false)
    setInputValue(formatTime(0));

    if (hasChangedKg) setHasChangedKg(false);
    if (hasChangedReps) setHasChangedReps(false);
    if (hasChangedTime) setHasChangedTime(false);

    if (!showExercise.exerciseLevel.suggested_weight_lbs &&
      showExercise.userProgramDayExercisesAttempt.length < 3) {
      setRapsValue(null)
      setDumbbellsValue(null)
      updateUserProgramDayExercise(dt, showExercise.id)
      setDurationValue("")
      setIsTimerActive(false);
      setIsStart(false)

      if (hasChangedKg) setHasChangedKg(false);
      if (hasChangedReps) setHasChangedReps(false);
      if (hasChangedTime) setHasChangedTime(false);
    }

    window.scrollTo({
      top: 200,  // 100 pixels from the top
      behavior: 'smooth',  // Smooth scroll behavior
    });
  };

  if (skipExerciseSuccess) {
    dispatch({ type: "USER_SKIP_EXERCISE_PURGE" });
    if (nextExercise) {
      setActiveExerciseFunc(nextExercise);
    } else {
      handleCompleteExercise();
    }
  }

  const handleActiveExercise = (exercise) => {
    setActiveExerciseLevel(exercise);
    setActiveExercise(exercise.id);
  };

  const intensityLabels = [
    "Very Easy",
    "Easy",
    "Slightly Easy",
    "Somewhat Easy",
    "Moderate",
    "Somewhat Hard",
    "Slightly Hard",
    "Hard",
    "Very Hard",
  ];

  // Function to handle selection
  const handleSelectIntensity = (event, weight) => {
    let main_weight = parseFloat(dumbbellsValue);

    let new_weight = main_weight + weight;

    setNewWeightValue(new_weight);
    setSelectedIntensity(event);
  };

  const getEasy = (bar) => {
    return bar == 1 ? "#00b050" : "#9B9B9B";
  };

  const getModerate = (bar) => {
    return bar == 2 ? "#0f02ff" : "#9B9B9B";
  };

  const getAdvanced = (bar) => {
    return bar == 3 ? "#fb1417" : "#9B9B9B";
  };

  const handleEdit = () => {
    //setIsEditing(true);
    setIsEditing((prev) => !prev);
    setIsTimeChanged(false);
  };

  function parseTime(input) {
    const parts = input.split(":");
    if (parts.length === 2) {
      const min = parseInt(parts[0] || "0", 10); // handles empty string before ':'
      const sec = parseInt(parts[1] || "0", 10);
      return min * 60 + sec;
    } else if (parts.length === 1 && input) {
      // e.g., just "30"
      return parseInt(input, 10);
    }
    return 0;
  }

  function formatTime(seconds) {
    return `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;
  }

  const handleChange = (e) => {
    setHasChangedTime(true)
    setInputValue(e.target.value);
    setIsPaused(false);
    setIsTimeChanged(true);
    const newSeconds = parseTime(e.target.value);
    setSeconds(newSeconds);
  };

  return (
    <>
      <CommonPageData>
        <section className="test1_001">
          <div className="container">
            {showExercise ? (

              <div className="row justify-content-center">
                <div className="col-12 col-xl-6 col-lg-12 col-md-12">
                  <div className="mb-3 d-flex justify-content-between exercise-header-details">
                    <h5>{showExercise.exercise.name}</h5>
                    <p className="instructions-text">{showExercise.exerciseLevel.instructions}</p>
                    <div className="set-container">
                      <>
                        <span className="set-label">SET</span>
                        {[...Array(3)].map((_, index) => (
                          <span
                            key={index}
                            className={`set-number ${index + 1 === showExercise.userProgramDayExercisesAttempt.length + 1 ? "active" : ""
                              }`}
                          >
                            {index + 1}
                          </span>
                        ))}
                      </>
                    </div>
                  </div>

                  <div
                    className="ssa box_video"
                    style={{ textAlign: "center" }}
                    data-click="0"
                  >

                    <TestVideoPlayer
                      playing={playing}
                      videoUrl={
                        showExercise.exerciseLevel.video +
                        "#t=" +
                        showExercise.exerciseLevel.video_start_time +
                        "," +
                        showExercise.exerciseLevel.video_end_time
                      }
                      posterUrl={showExercise.exerciseLevel.video_cover}
                      className={`${showExercise.exerciseLevel.video_flip == true ||
                        showExercise.position == 2
                        ? "video flip-video"
                        : "video"
                        }`}
                      showExercise={showExercise}
                    />
                    {showCounter && <a className="timer">{counter}</a>}
                    {showExercise.feel_it_show == "1" ? (
                      <img
                        className={`img-fluid feel-it-here ${CheckPosImage(
                          showExercise.feel_it_position
                            ? showExercise.feel_it_position
                            : ""
                        )}`}
                        crossOrigin="anonymous"
                        src={
                          showExercise.exerciseLevel &&
                            showExercise.exerciseLevel.body_part
                            ? showExercise.exerciseLevel.body_part.male_image
                            : obliques
                        }
                        alt={"Feel IT"}
                        title={"Feel It Here Image"}
                      />
                    ) : (
                      ""
                    )}
                    {showExercise.text_show == "1" ? (
                      <p
                        className={`text-placement ${CheckPosText(
                          showExercise.text_position
                        )}`}
                      >
                        {checkOrientationText(showExercise.position)}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  {!isStart ? (
                    <div className="timer_box exercise_data">
                      <ul>
                        {showExercise.exerciseLevel.suggested_weight_lbs ? (
                          <li>
                            <div style={styles.container}>
                              <svg
                                width="27"
                                height="15"
                                viewBox="0 0 27 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M26.0124 5.99222C25.9115 5.78411 25.8169 5.56338 25.5205 5.60753C25.3061 5.63906 25.1484 5.84717 25.1484 6.1688C25.1358 7.2346 25.1421 8.29409 25.1484 9.35988C25.1484 9.43556 25.161 9.50493 25.1799 9.5743C25.2367 9.75719 25.3439 9.90224 25.5457 9.92116C25.7412 9.94008 25.8673 9.82656 25.9493 9.6626C25.9682 9.61845 25.9935 9.5743 26.0124 9.53647C26.0124 8.35085 26.0124 7.17154 26.0124 5.99222Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M21.4528 7.75174C21.4528 5.97331 21.4465 4.19489 21.4528 2.41646C21.4528 1.81734 21.2889 1.29391 20.8033 0.92813C20.0465 0.35424 19.0059 0.72632 18.6717 1.6786C18.5834 1.93086 18.5645 2.18942 18.5645 2.4543C18.5645 3.70928 18.5582 4.95797 18.5708 6.21296C18.5708 6.38954 18.5329 6.4463 18.3437 6.4463C14.9824 6.43999 11.6273 6.43999 8.26599 6.4463C8.06418 6.4463 8.04526 6.37693 8.04526 6.21296C8.05157 4.95166 8.05157 3.69037 8.05157 2.42907C8.05157 1.83626 7.8876 1.31282 7.402 0.934435C6.64522 0.354239 5.56681 0.745241 5.2641 1.70383C5.20104 1.89302 5.1632 2.08222 5.1632 2.28402C5.1632 5.94809 5.15689 9.60584 5.1695 13.2699C5.1695 13.9195 5.4533 14.4492 6.05241 14.7456C6.80288 15.1114 7.71102 14.651 7.96328 13.7933C8.03265 13.5537 8.05787 13.3141 8.05787 13.0681C8.05787 11.8131 8.05787 10.5644 8.05157 9.30944C8.05157 9.14547 8.0831 9.08871 8.25968 9.08871C11.6273 9.09502 14.995 9.09502 18.3627 9.08871C18.5392 9.08871 18.5771 9.14547 18.5771 9.30944C18.5771 10.6843 18.5645 12.0591 18.596 13.4402C18.6149 14.3231 19.3906 14.96 20.2231 14.8528C20.8348 14.7772 21.3898 14.1465 21.4402 13.4654C21.4528 13.3204 21.4528 13.169 21.4528 13.024C21.4528 11.2581 21.4528 9.50494 21.4528 7.75174Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M4.5517 7.73914C4.5517 6.50938 4.5517 5.27962 4.5517 4.04985C4.5517 3.44443 4.28683 3.04712 3.79492 2.88946C2.95616 2.62459 2.23092 3.15433 2.23092 4.04354C2.22461 6.3391 2.23092 8.62836 2.23092 10.9239C2.23092 11.2077 2.20569 11.4978 2.25614 11.7816C2.35705 12.3555 2.82372 12.7023 3.47329 12.6771C4.04088 12.6582 4.50125 12.2609 4.52647 11.7122C4.55801 11.0185 4.54539 10.3185 4.5517 9.62478C4.55801 9.00044 4.5517 8.36979 4.5517 7.73914Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M24.4613 7.75805C24.4613 6.50306 24.4613 5.25437 24.4613 3.99938C24.4613 3.50117 24.2595 3.11017 23.7928 2.92728C23.3387 2.7507 22.891 2.78223 22.5063 3.11648C22.2477 3.34351 22.1405 3.63992 22.1405 3.96785C22.1405 6.49044 22.1342 9.01304 22.1405 11.5356C22.1405 12.1347 22.5315 12.5888 23.0676 12.6645C23.7171 12.7591 24.2342 12.4627 24.4108 11.9014C24.4613 11.7437 24.4613 11.5798 24.4613 11.4158C24.4613 10.1987 24.4613 8.98151 24.4613 7.75805Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M0.843262 7.75806C0.843262 8.25627 0.843262 8.75449 0.843262 9.259C0.843262 9.38513 0.843262 9.50496 0.893714 9.61847C0.969392 9.79506 1.08921 9.92749 1.29733 9.91488C1.50544 9.90227 1.61896 9.75721 1.67572 9.58063C1.70725 9.46712 1.71356 9.34099 1.71356 9.21486C1.71356 8.24366 1.71356 7.26616 1.71356 6.29496C1.71356 6.17514 1.70725 6.04901 1.67572 5.92918C1.61896 5.7463 1.50544 5.60755 1.29733 5.59494C1.08921 5.58233 0.969392 5.72107 0.893714 5.89765C0.849568 6.00486 0.843262 6.11838 0.843262 6.2382C0.843262 6.74902 0.843262 7.25354 0.843262 7.75806Z"
                                  fill="#9B9B9B"
                                />
                              </svg>
                              <h6>Suggested Weight</h6>
                              <p>
                                {showExercise.exerciseLevel.suggested_weight_lbs
                                  ? showExercise.exerciseLevel.suggested_weight_lbs
                                  : ""}{" "}
                                (lbs)
                              </p>
                            </div>
                          </li>
                        ) : (
                          ""
                        )}
                        {showExercise.exerciseLevel.metric == 10 ? (
                          <li>
                            <div style={styles.container}>
                              <h6>Reps</h6>
                              <p>
                                {showExercise.exerciseLevel.reps
                                  ? showExercise.exerciseLevel.reps
                                  : ""}
                              </p>
                            </div>
                          </li>
                        ) : (
                          ""
                        )}
                        {showExercise.exerciseLevel.metric == 20 ? (
                          <li>
                            <div style={styles.container}>
                              <svg
                                width="21"
                                height="21"
                                viewBox="0 0 21 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.0722 0.866455C4.54769 0.866455 0.0693359 5.34481 0.0693359 10.8693C0.0693359 16.3938 4.54769 20.8722 10.0722 20.8722C15.5967 20.8722 20.0751 16.3938 20.0751 10.8693C20.0751 5.34481 15.5967 0.866455 10.0722 0.866455ZM14.1383 14.1624C13.8858 14.4716 13.4529 14.5025 13.1076 14.2294C11.9635 13.3172 10.8298 12.405 9.68569 11.4929C9.46409 11.3177 9.35587 11.1012 9.36102 10.8126C9.36617 9.90047 9.36102 8.98315 9.36102 8.07099C9.36102 7.12275 9.36102 6.17967 9.36102 5.23143C9.36102 4.90161 9.58777 4.62848 9.88667 4.55633C10.201 4.48418 10.5205 4.61817 10.6752 4.89646C10.7525 5.0356 10.7628 5.19021 10.7628 5.34481C10.7628 7.01453 10.7628 8.6791 10.7576 10.3488C10.7576 10.5034 10.8091 10.591 10.9225 10.6838C11.9429 11.498 12.9633 12.3123 13.9837 13.1317C14.3444 13.41 14.4011 13.8377 14.1383 14.1624Z"
                                  fill="#9B9B9B"
                                />
                              </svg>
                              <h6>Time</h6>
                              <p>
                                {showExercise.exerciseLevel.time
                                  ? EXERCISE_TIMES[showExercise.exerciseLevel.time]
                                  : ""}
                              </p>
                            </div>
                          </li>
                        ) : (
                          ""
                        )}
                        {showExercise.exerciseLevel.level ? (
                          <li>
                            <div style={styles.container}>
                              <Dropdown className={"level-change-link"}>
                                <Dropdown.Toggle
                                  variant="success"
                                  id="dropdown-basic"
                                >
                                  <svg
                                    width="15"
                                    height="25"
                                    viewBox="0 0 15 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="0.853027"
                                      y="16.9424"
                                      width="2.45446"
                                      height="7.36337"
                                      fill="#9B9B9B"
                                    />
                                    <rect
                                      x="6.23291"
                                      y="8.96558"
                                      width="2.45446"
                                      height="15.3404"
                                      fill="#9B9B9B"
                                    />
                                    <rect
                                      x="11.6133"
                                      y="0.988525"
                                      width="2.45446"
                                      height="23.3173"
                                      fill="#9B9B9B"
                                    />
                                  </svg>
                                  <h6>Level</h6>
                                  <p
                                    className={`level level${showExercise.exerciseLevel.level.id}`}
                                  >
                                    {" "}
                                    {showExercise.exerciseLevel.level
                                      ? showExercise.exerciseLevel.level.name
                                      : ""}
                                  </p>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className={"level-change-link-menu"}>
                                  <h4>Exercise Levels</h4>
                                  <div id="wrapper1">
                                    <img src={barchart} alt="barchart" />
                                    <div className="btn_chart text-center">
                                      <Link
                                        to={`/program/change-level`}
                                        state={{
                                          exercise: showExercise,
                                          activeDayId: activeDay,
                                          programId: program.id,
                                          redirectLink: "/assessment-timer",
                                        }}
                                        className="theme_btn1 small_btn"
                                      >
                                        Change Level
                                      </Link>
                                    </div>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>{" "}
                            </div>
                          </li>
                        ) : (
                          ""
                        )}
                        {showExercise.exerciseLevel.exerciseEducationVideo
                          ?.length > 0 ? (
                          <li>
                            <div style={styles.container}>
                              <Link
                                to="#"
                                className="edu popup-youtube-custom"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleShow();
                                }}
                              >
                                <svg
                                  width="28"
                                  height="24"
                                  viewBox="0 0 26 22"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M25.7266 5.55698C25.5718 5.86026 25.3072 6.00867 24.991 6.11837C21.2355 7.44118 17.48 8.7769 13.7309 10.1126C13.4664 10.2094 13.2276 10.203 12.9566 10.1126C9.1624 8.75755 5.36172 7.41537 1.56104 6.0732C1.28357 5.97641 1.1029 5.79573 0.960938 5.56343C0.960938 5.42147 0.960938 5.27305 0.960938 5.13109C1.01256 4.87298 1.18678 4.71812 1.41908 4.61487C1.76753 4.46001 2.12889 4.35676 2.49024 4.22771C5.16814 3.2856 7.83958 2.3435 10.5175 1.40785C11.3176 1.13038 12.1113 0.846462 12.9114 0.562541C13.2083 0.459296 13.4922 0.459296 13.7826 0.562541C16.0346 1.34978 18.2801 2.14347 20.5322 2.93716C21.9905 3.45338 23.4488 3.96314 24.9071 4.47936C25.0233 4.51808 25.133 4.5568 25.2491 4.60842C25.5072 4.72457 25.7073 4.87944 25.7331 5.18271C25.7266 5.30532 25.7266 5.43437 25.7266 5.55698Z"
                                    fill="#0F02FF"
                                  />
                                  <path
                                    d="M6.05886 10.8741C6.05886 10.4095 6.05886 9.93841 6.05886 9.47381C6.05886 9.20279 6.05886 9.2028 6.31051 9.28668C8.36249 10.0158 10.4145 10.7386 12.46 11.4742C13.0601 11.6871 13.6344 11.6871 14.2281 11.4742C16.2736 10.7386 18.332 10.0158 20.3775 9.28023C20.5647 9.20925 20.6356 9.2157 20.6292 9.448C20.6163 10.3707 20.6163 11.2999 20.6292 12.2227C20.6356 12.7131 20.4485 13.0938 20.0807 13.4035C19.4871 13.9004 18.7837 14.1714 18.0545 14.3844C16.0284 14.9909 13.9635 15.1458 11.8599 14.978C10.4338 14.8619 9.04003 14.6038 7.71076 14.0553C7.29133 13.881 6.89772 13.6681 6.55572 13.3648C6.22018 13.068 6.0395 12.7002 6.0524 12.242C6.06531 11.7904 6.05886 11.3322 6.05886 10.8741Z"
                                    fill="#0F02FF"
                                  />
                                  <path
                                    d="M23.9849 8.00903C23.9849 9.20279 23.9849 10.3707 23.9849 11.5387C23.9849 12.3969 23.9914 13.2616 23.9785 14.1198C23.9785 14.2618 24.0172 14.3456 24.1333 14.436C24.9141 15.0425 24.9077 16.1653 24.114 16.7525C23.9978 16.8429 23.9785 16.9332 23.9785 17.0558C23.9785 18.1657 23.9849 19.2756 23.9785 20.3854C23.9785 20.7274 23.772 21.0049 23.4687 21.1017C23.1719 21.192 22.8557 21.0888 22.675 20.8436C22.5653 20.6952 22.5266 20.5274 22.5266 20.3467C22.5266 19.2497 22.5266 18.1592 22.5331 17.0623C22.5331 16.9203 22.5008 16.8364 22.3782 16.7461C21.6168 16.1718 21.6039 15.0425 22.3588 14.4618C22.5008 14.3521 22.5331 14.2489 22.5331 14.0811C22.5266 12.313 22.5331 10.545 22.5266 8.77046C22.5266 8.57042 22.5911 8.49944 22.7718 8.44137C23.1654 8.31231 23.5591 8.1639 23.9849 8.00903Z"
                                    fill="#0F02FF"
                                  />
                                </svg>
                                <h6>Educational</h6>
                                <h6>Video</h6>
                              </Link>
                            </div>
                          </li>
                        ) : (
                          ""
                        )}
                      </ul>
                      <ul>


                        {!nextExercise && (
                          <li>
                            <Button
                              style={{
                                ...styles.buttonComplete,
                                ...(isHovered ? styles.buttonHover : {}),
                              }}
                              disabled={isTimerActive || isCompleteDisable}
                              id={"completeExerciseButton"}
                              onClick={() => handleCompleteExercise()}
                            >
                              Complete
                            </Button>
                            {showExercise.userProgramDayExercisesAttempt.length < 3 ? (
                              <Link
                                to="#"
                                className="repeat-circuit-btn mb-1"
                                onClick={handleRepeatCircuit}
                              >
                                Repeat Circuit
                              </Link>
                            ) : (
                              ""
                            )}
                          </li>
                        )}
                      </ul>
                    </div>
                  ) : (
                    <div className="timer_box">
                      <ul className="border_1">
                        {showExercise.exerciseLevel.suggested_weight_lbs ? (
                          <li>
                            <div style={styles.container}>
                              <input
                                id={"dumbbells"}
                                type="number"
                                placeholder="10-15lbs"
                                className={`form-control form-2 custom-input ${hasChangedKg ? "input-changed" : ""}`}
                                onChange={(e) => setDumbbellsValueFunc(e)}
                                step={2}
                                min={0}
                                max={1000}
                                value={dumbbellsValue}
                                style={styles.input}
                              />
                              <p style={styles.label}>POUNDS</p>
                              {errorDumbell && (
                                <span className="show-error">{errorDumbell}</span>
                              )}
                            </div>
                          </li>
                        ) : (
                          ""
                        )}
                        {showExercise.exerciseLevel.metric == 10 ? (
                          <li>
                            <div style={styles.container}>
                              <input
                                id={"raps"}
                                type="number"
                                placeholder="10"
                                className={`form-control form-2 custom-input ${hasChangedReps ? "input-changed" : ""}`}
                                onChange={(e) => setRapsValueFunc(e)}
                                min={0}
                                value={rapsValue || ""}
                                max={1000}
                                style={styles.input}
                              />
                              <p style={styles.label}>REPS</p>
                              {error && (
                                <span className="show-error">{error}</span>
                              )}
                            </div>
                          </li>
                        ) : (
                          <>
                            <li>
                              <div style={styles.container}>
                                {isEditing ? (
                                  <input
                                    type="text"
                                    className={`form-control form-2 custom-input ${hasChangedTime ? "input-changed" : ""}`}
                                    style={styles.input}
                                    value={inputValue}
                                    onChange={handleChange}
                                  />
                                ) : (
                                  <>
                                    <input
                                      type="text"
                                      className={`form-control form-2 custom-input ${hasChangedTime ? "input-changed" : ""}`}
                                      style={styles.input}
                                      onChange={(e) => setTimeValueFunc(e)}
                                      value={formatTime(seconds)}
                                      readOnly
                                    />
                                  </>
                                )}
                                <div>
                                  {isEditing ? (
                                    <FaTimes style={styles.editIcon} onClick={handleEdit} />
                                  ) : (
                                    <FaEdit style={styles.editIcon} onClick={handleEdit} />
                                  )}
                                </div>
                                <p style={styles.label}>TIME</p>

                                {error && (
                                  <span className="show-error">{error}</span>
                                )}

                              </div>
                            </li>
                          </>
                        )}

                        {isStart &&
                          (showExercise.exerciseLevel.metric == 20 ? (
                            <>
                              {!isTimerActive ? (
                                seconds == 0 ? (
                                  <div className="d-flex">
                                    <Button
                                      className="mr-20 timer-btn"
                                      style={{
                                        ...styles.buttonStart,
                                        ...(isHovered ? styles.buttonHover : {}),
                                      }}
                                      onClick={() => handleStart()}
                                      disabled={!isPaused || isCompleted || isEditing}
                                    >
                                      <svg
                                        fill="#000000"
                                        version="1.1"
                                        id="Layer_1"
                                        viewBox="0 0 503.607 503.607"
                                      >
                                        <g transform="translate(1 1)">
                                          <g>
                                            <g>
                                              <path
                                                d="M421.07,148.419l12.665-12.665l6.655,6.774c1.679,1.679,3.357,2.518,5.875,2.518s4.197-0.839,5.875-2.518l7.554-6.715
                                              c12.59-13.43,12.59-34.413,0-47.003l-12.59-12.59c-13.43-12.59-34.413-12.59-47.003,0l-6.715,6.715
                                              c-3.357,3.357-3.357,8.393,0,11.751l5.407,5.504l-13.067,13.067C354.741,88.723,317.006,72.4,275.879,67.62V49.361h16.787
                                              c5.036,0,8.393-3.357,8.393-8.393V7.393c0-5.036-3.357-8.393-8.393-8.393h-83.934c-5.036,0-8.393,3.357-8.393,8.393v33.574
                                              c0,5.036,3.357,8.393,8.393,8.393h16.787v18.259c-41.334,4.805-79.24,21.272-110.313,46.011l-13.07-13.07l5.875-5.875
                                              c3.357-3.357,3.357-8.393,0-11.751l-5.875-6.715c-12.59-12.59-33.574-12.59-46.164,0l-13.43,13.43
                                              c-12.59,12.59-12.59,33.574,0,46.164l6.715,6.715c1.679,1.679,3.357,2.518,5.875,2.518c1.679,0,4.197-0.839,5.036-2.518
                                              l6.715-6.715l13.07,13.07c-29.687,37.289-47.483,84.411-47.483,135.494c0,59.607,23.896,113.488,62.503,152.804
                                              c0.355,0.575,0.777,1.126,1.287,1.636c0.588,0.588,1.179,1.067,1.803,1.449c39.43,38.589,93.367,62.341,152.636,62.341
                                              c59.409,0,113.462-23.863,152.916-62.613c0.547-0.332,1.067-0.721,1.524-1.177c0.509-0.509,0.932-1.061,1.287-1.636
                                              c38.608-39.316,62.503-93.196,62.503-152.804C468.928,233.081,450.981,185.781,421.07,148.419z M434.515,87.971l12.59,12.59
                                              c6.715,5.875,6.715,15.948,0,22.662l-0.839,0.839L411.013,88.81C417.728,82.095,427.8,82.095,434.515,87.971z M435.354,292.771
                                              h16.598c-2.04,49.134-21.892,93.865-53.237,127.872l-16.239-16.239c-3.357-3.357-8.393-3.357-11.751,0
                                              c-3.357,3.357-3.357,8.393,0,11.751l16.239,16.239c-34.007,31.345-78.739,51.196-127.872,53.237v-16.598
                                              c0-5.036-3.357-8.393-8.393-8.393s-8.393,3.357-8.393,8.393v16.598c-49.134-2.04-93.865-21.892-127.872-53.237l16.239-16.239
                                              c3.357-3.357,3.357-8.393,0-11.751c-3.357-3.357-8.393-3.357-11.751,0l-16.239,16.239
                                              c-31.345-34.007-51.196-78.738-53.237-127.872h16.598c5.036,0,8.393-3.357,8.393-8.393c0-5.036-3.357-8.393-8.393-8.393H49.445
                                              c2.04-49.134,21.892-93.865,53.237-127.872l16.239,16.239c1.679,1.679,3.357,2.518,5.875,2.518c2.518,0,4.197-0.839,5.875-2.518
                                              c3.357-3.357,3.357-8.393,0-11.751l-16.239-16.239c31.95-29.449,73.366-48.753,119.006-52.673
                                              c0.435,0.051,0.873,0.086,1.312,0.086c2.663-0.19,5.148-0.335,7.554-0.439v16.387c0,5.036,3.357,8.393,8.393,8.393
                                              s8.393-3.357,8.393-8.393V83.318c2.629,0.105,5.389,0.256,8.393,0.456c0.328,0,0.64-0.016,0.941-0.044
                                              c43.023,3.797,82.275,21.261,113.351,48.006c1.731,1.681,3.45,3.237,5.099,4.713L370.725,152.6
                                              c-3.357,3.357-3.357,8.393,0,11.751c1.679,1.679,3.357,2.518,5.875,2.518c2.518,0,4.197-0.839,5.875-2.518l16.107-16.107
                                              c1.522,1.692,3.123,3.442,4.877,5.195c0.321,0.482,0.682,0.885,1.059,1.25c27.979,33.104,45.522,75.267,47.434,121.294h-16.598
                                              c-5.036,0-8.393,3.357-8.393,8.393C426.961,289.413,430.318,292.771,435.354,292.771z M411.013,136.652
                                              c-0.27-0.27-0.567-0.567-0.874-0.874c-1.091-1.17-2.195-2.327-3.311-3.473c-0.411-0.844-0.968-1.646-1.69-2.368
                                              c-0.67-0.67-1.409-1.201-2.187-1.603c-1.058-1.209-2.231-2.461-3.688-3.433l11.751-11.751l11.751,11.751L411.013,136.652z
                                              M217.125,15.787h67.148v16.787h-16.787h-33.574h-16.787V15.787z M242.305,66.148V49.361h16.787v16.787c-2.518,0-5.875,0-8.393,0
                                              S244.823,66.148,242.305,66.148z M54.292,124.902c-5.875-6.715-5.875-16.787,0-22.662l13.43-13.43
                                              c2.518-3.357,6.715-5.036,10.911-5.036s8.393,1.679,10.911,4.197l0.839,2.518l-1.928,1.928c-1.423,0.358-2.786,1.108-3.947,2.269
                                              l-23.502,23.502c-1.161,1.161-1.911,2.524-2.269,3.947l-3.607,3.607L54.292,124.902z M84.645,118.05l5.739-5.739l11.751,11.751
                                              c-1.679,1.679-4.197,4.197-5.875,5.875c-1.679,1.679-4.197,3.357-5.875,5.875l-11.751-11.751L84.645,118.05z"
                                              />
                                              <path
                                                d="M259.092,251.873V141.689c0-5.036-3.357-8.393-8.393-8.393s-8.393,3.357-8.393,8.393v110.185
                                              c-14.439,3.752-25.18,16.934-25.18,32.504c0,18.466,15.108,33.574,33.574,33.574s33.574-15.108,33.574-33.574
                                              C284.272,268.807,273.53,255.625,259.092,251.873z M250.698,301.164c-9.233,0-16.787-7.554-16.787-16.787
                                              c0-9.233,7.554-16.787,16.787-16.787c9.233,0,16.787,7.554,16.787,16.787C267.485,293.61,259.931,301.164,250.698,301.164z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </svg>{" "}
                                      <small>Start Timer</small>
                                    </Button>
                                  </div>
                                ) : (
                                  <Button
                                    className="theme_btn_yellow mr-20"
                                    style={{
                                      ...styles.button,
                                      ...(isHovered ? styles.buttonHover : {}),
                                    }}
                                    onClick={() => handleResume()}
                                    disabled={isCompleted}
                                  >
                                    Resume
                                  </Button>
                                )
                              ) : (
                                <Button
                                  className="theme_btn_yellow mr-20"
                                  style={{
                                    ...styles.button,
                                    ...(isHovered ? styles.buttonHover : {}),
                                  }}
                                  onClick={() => handlePause()}
                                  disabled={isCompleted}
                                >
                                  Pause
                                </Button>
                              )}
                              {seconds !== 0 && isTimeChanged && (
                                <>
                                  <Button
                                    className="theme_btn1 mr-20 btn-finish"
                                    style={{
                                      ...styles.button,
                                      ...(isHovered ? styles.buttonHover : {}),
                                    }}
                                    onClick={() => handleFinishNew()}
                                    disabled={isCompleted}
                                  >
                                    Finish
                                  </Button>
                                  <Button
                                    className="theme_btn1 mr-20 ml-5"
                                    style={{
                                      ...styles.buttonNext,
                                      ...(isHovered ? styles.buttonHover : {}),
                                    }}
                                    onClick={() => handleFinish()}
                                    disabled={isCompleted}
                                  >
                                    Next
                                  </Button>
                                </>
                              )}
                            </>
                          ) : (
                            <Button
                              className="mr-20"
                              style={{
                                ...styles.button,
                                ...(isHovered ? styles.buttonHover : {}),
                              }}
                              onClick={() => handleFinish()}
                            >
                              Done
                            </Button>
                          ))}

                      </ul>

                      <ul>
                        <li>
                          <div style={styles.container}>
                            {showExercise?.exerciseLevel?.exerciseEquipmentUses
                              ?.length > 0 ? (
                              showExercise.exerciseLevel.exerciseEquipmentUses.map(
                                (item, index) => (
                                  <div key={item.id}>
                                    <p
                                      className={index === 1 ? "black-line" : ""}
                                      style={styles.equipments}
                                    >
                                      {item.title}
                                    </p>
                                  </div>
                                )
                              )
                            ) : (
                              <p>No Equipment</p>
                            )}


                          </div>
                        </li>
                        {showExercise.exerciseLevel.level ? (
                          <li>
                            <div style={styles.container}>
                              <Dropdown className={"level-change-link"}>
                                <Dropdown.Toggle
                                  variant="success"
                                  id="dropdown-basic"
                                >
                                  <svg
                                    width="15"
                                    height="25"
                                    viewBox="0 0 15 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="0.853027"
                                      y="16.9424"
                                      width="2.45446"
                                      height="7.36337"
                                      fill="#9B9B9B"
                                    />
                                    <rect
                                      x="6.23291"
                                      y="8.96558"
                                      width="2.45446"
                                      height="15.3404"
                                      fill="#9B9B9B"
                                    />
                                    <rect
                                      x="11.6133"
                                      y="0.988525"
                                      width="2.45446"
                                      height="23.3173"
                                      fill="#9B9B9B"
                                    />
                                  </svg>
                                  <h6>Level</h6>
                                  <p
                                    className={`level level${showExercise.exerciseLevel.level.id}`}
                                  >
                                    {" "}
                                    {showExercise.exerciseLevel.level
                                      ? showExercise.exerciseLevel.level.name
                                      : ""}
                                  </p>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className={"level-change-link"}>
                                  <h4 className="text-center">Exercise Levels</h4>
                                  <div id="wrapper1">
                                    <ul className="" id="chart01">
                                      <li>
                                        <span></span>{" "}
                                        <i>
                                          <b>Level 1</b> Easy{" "}
                                        </i>
                                      </li>
                                      <li>
                                        <span></span>{" "}
                                        <i>
                                          <b>Level 2</b> Moderate{" "}
                                        </i>
                                      </li>
                                      <li>
                                        <span></span>{" "}
                                        <i>
                                          <b>Level 3</b> Advanced{" "}
                                        </i>
                                      </li>
                                    </ul>
                                    {/* <img src={barchart} alt="barchart" /> */}
                                    <div className="btn_chart text-center">
                                      <Link
                                        to={`/program/change-level`}
                                        state={{
                                          exercise: showExercise,
                                          activeDayId: activeDay,
                                          programId: program.id,
                                          redirectLink: "/assessment-timer",
                                        }}
                                        className="theme_btn1 small_btn"
                                      >
                                        Change Level
                                      </Link>
                                    </div>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </li>
                        ) : (
                          ""
                        )}
                        {showExercise &&
                          showExercise.exerciseLevel &&
                          showExercise.exerciseLevel.exerciseEducationVideo ? (
                          <li>
                            <div style={styles.container}>
                              <Link
                                to="#"
                                className="edu popup-youtube-custom d-block"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handlePause();
                                  handleShow();
                                }}
                              >
                                <svg
                                  width="28"
                                  height="24"
                                  viewBox="0 0 26 22"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M25.7266 5.55698C25.5718 5.86026 25.3072 6.00867 24.991 6.11837C21.2355 7.44118 17.48 8.7769 13.7309 10.1126C13.4664 10.2094 13.2276 10.203 12.9566 10.1126C9.1624 8.75755 5.36172 7.41537 1.56104 6.0732C1.28357 5.97641 1.1029 5.79573 0.960938 5.56343C0.960938 5.42147 0.960938 5.27305 0.960938 5.13109C1.01256 4.87298 1.18678 4.71812 1.41908 4.61487C1.76753 4.46001 2.12889 4.35676 2.49024 4.22771C5.16814 3.2856 7.83958 2.3435 10.5175 1.40785C11.3176 1.13038 12.1113 0.846462 12.9114 0.562541C13.2083 0.459296 13.4922 0.459296 13.7826 0.562541C16.0346 1.34978 18.2801 2.14347 20.5322 2.93716C21.9905 3.45338 23.4488 3.96314 24.9071 4.47936C25.0233 4.51808 25.133 4.5568 25.2491 4.60842C25.5072 4.72457 25.7073 4.87944 25.7331 5.18271C25.7266 5.30532 25.7266 5.43437 25.7266 5.55698Z"
                                    fill="#0F02FF"
                                  />
                                  <path
                                    d="M6.05886 10.8741C6.05886 10.4095 6.05886 9.93841 6.05886 9.47381C6.05886 9.20279 6.05886 9.2028 6.31051 9.28668C8.36249 10.0158 10.4145 10.7386 12.46 11.4742C13.0601 11.6871 13.6344 11.6871 14.2281 11.4742C16.2736 10.7386 18.332 10.0158 20.3775 9.28023C20.5647 9.20925 20.6356 9.2157 20.6292 9.448C20.6163 10.3707 20.6163 11.2999 20.6292 12.2227C20.6356 12.7131 20.4485 13.0938 20.0807 13.4035C19.4871 13.9004 18.7837 14.1714 18.0545 14.3844C16.0284 14.9909 13.9635 15.1458 11.8599 14.978C10.4338 14.8619 9.04003 14.6038 7.71076 14.0553C7.29133 13.881 6.89772 13.6681 6.55572 13.3648C6.22018 13.068 6.0395 12.7002 6.0524 12.242C6.06531 11.7904 6.05886 11.3322 6.05886 10.8741Z"
                                    fill="#0F02FF"
                                  />
                                  <path
                                    d="M23.9849 8.00903C23.9849 9.20279 23.9849 10.3707 23.9849 11.5387C23.9849 12.3969 23.9914 13.2616 23.9785 14.1198C23.9785 14.2618 24.0172 14.3456 24.1333 14.436C24.9141 15.0425 24.9077 16.1653 24.114 16.7525C23.9978 16.8429 23.9785 16.9332 23.9785 17.0558C23.9785 18.1657 23.9849 19.2756 23.9785 20.3854C23.9785 20.7274 23.772 21.0049 23.4687 21.1017C23.1719 21.192 22.8557 21.0888 22.675 20.8436C22.5653 20.6952 22.5266 20.5274 22.5266 20.3467C22.5266 19.2497 22.5266 18.1592 22.5331 17.0623C22.5331 16.9203 22.5008 16.8364 22.3782 16.7461C21.6168 16.1718 21.6039 15.0425 22.3588 14.4618C22.5008 14.3521 22.5331 14.2489 22.5331 14.0811C22.5266 12.313 22.5331 10.545 22.5266 8.77046C22.5266 8.57042 22.5911 8.49944 22.7718 8.44137C23.1654 8.31231 23.5591 8.1639 23.9849 8.00903Z"
                                    fill="#0F02FF"
                                  />
                                </svg>

                                <h6 className="mt-2">Educational Video</h6>
                              </Link>
                            </div>
                          </li>
                        ) : (
                          ""
                        )}


                        <li>
                          <div style={styles.container}>
                            <Link
                              className="info-icon"
                              onClick={() => {
                                setIsModalOpen(true);
                              }}
                            >
                              <svg
                                width="28"
                                height="24"
                                xmlns="http://www.w3.org/2000/svg"
                                shape-rendering="geometricPrecision"
                                text-rendering="geometricPrecision"
                                image-rendering="optimizeQuality"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                viewBox="0 0 512 512"
                              >
                                <path
                                  fill-rule="nonzero"
                                  d="M256 0c70.691 0 134.695 28.656 181.021 74.979C483.344 121.305 512 185.309 512 256c0 70.691-28.656 134.695-74.979 181.018C390.695 483.344 326.691 512 256 512c-70.691 0-134.695-28.656-181.018-74.982C28.656 390.695 0 326.691 0 256S28.656 121.305 74.982 74.979C121.305 28.656 185.309 0 256 0zm-10.029 160.379c0-4.319.761-8.315 2.282-11.988 1.515-3.66 3.797-6.994 6.836-9.98 3.028-2.98 6.341-5.241 9.916-6.758 3.593-1.511 7.463-2.282 11.603-2.282 4.143 0 8.006.771 11.564 2.278 3.561 1.521 6.828 3.782 9.808 6.779 2.976 2.987 5.212 6.31 6.695 9.973 1.489 3.663 2.236 7.659 2.236 11.978 0 4.195-.739 8.128-2.229 11.767-1.483 3.631-3.709 6.993-6.692 10.046-2.965 3.043-6.232 5.342-9.79 6.878-3.569 1.528-7.432 2.306-11.592 2.306-4.259 0-8.206-.764-11.834-2.278-3.604-1.522-6.913-3.807-9.892-6.832-2.973-3.046-5.209-6.383-6.685-10.032-1.486-3.646-2.226-7.596-2.226-11.855zm13.492 179.381c-1.118 4.002-3.375 11.837 3.316 11.837 1.451 0 3.299-.81 5.5-2.412 2.387-1.721 5.125-4.336 8.192-7.799 3.116-3.53 6.362-7.701 9.731-12.507 3.358-4.795 6.888-10.292 10.561-16.419a1.39 1.39 0 011.907-.484l12.451 9.237c.593.434.729 1.262.34 1.878-5.724 9.952-11.512 18.642-17.362 26.056-5.899 7.466-11.879 13.66-17.936 18.553l-.095.07c-6.057 4.908-12.269 8.602-18.634 11.077-17.713 6.86-45.682 5.742-53.691-14.929-5.062-13.054-.897-27.885 3.085-40.651l20.089-60.852c1.286-4.617 2.912-9.682 3.505-14.439.974-7.915-2.52-13.032-11.147-13.032h-17.562a1.402 1.402 0 01-1.395-1.399l.077-.484 4.617-16.801a1.39 1.39 0 011.356-1.02l89.743-2.815a1.39 1.39 0 011.434 1.34l-.063.445-38.019 125.55zm151.324-238.547C371.178 61.606 316.446 37.101 256 37.101c-60.446 0-115.174 24.501-154.784 64.112C61.606 140.822 37.101 195.554 37.101 256c0 60.446 24.505 115.178 64.115 154.784 39.606 39.61 94.338 64.115 154.784 64.115s115.178-24.505 154.787-64.115c39.611-39.61 64.112-94.338 64.112-154.784s-24.505-115.178-64.112-154.787z"
                                  fill="#0F02FF"
                                />
                              </svg>
                              <h6>Info</h6>
                            </Link>
                          </div>
                        </li>
                      </ul>


                      {isStart && (
                        <Link
                          to="#"
                          className="mb-4 text-dark float-none float-md-right"
                          onClick={() => {
                            setShowExerciseSkipModal(true);
                          }}
                        >
                          {"SKIP>>"}
                        </Link>
                      )}


                      {showExercise.exerciseLevel
                        ? showExercise.exerciseLevel?.exerciseEquipmentUses?.title
                        : ""}
                      <textarea
                        className="form-control form-2 text-left p-3"
                        rows="5"
                        maxLength="500"
                        name="note"
                        id="note"
                        placeholder="Notes"
                        onChange={(e) => setNoteValueFunc(e)}
                      ></textarea>
                      {errorNote && (
                        <span className="show-error">{errorNote}</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <ExerciseEducationalVideoModal
            show={showEducationalModal}
            handleClose={handleClose}
            videos={
              showExercise
                ? showExercise.exerciseLevel
                  ? showExercise.exerciseLevel.exerciseEducationVideo
                  : null
                : null
            }
          />
          <SkipExerciseModal
            show={showExerciseSkipModal}
            handleClose={handleCloseExerciseSkipModal}
            skipTestReasons={skipTestReason ? skipTestReason : null}
            exerciseId={showExercise ? showExercise.id : null}
            dayId={showExercise ? showExercise.user_program_day_id : null}
          />
          <StatusCheckoutModal
            show={showStatusOutModal}
            handleClose={handleStatusOutModal}
            dayId={showExercise ? showExercise.user_program_day_id : null}
          />

          <Modal
            show={showWeight}
            onHide={handleCloseWeight}
            id="user-weight-modal"
            centered
            size="xl"
          >
            <Modal.Header>
              <h3 className="text-center m-2">Select Exercise Intensity</h3>
            </Modal.Header>

            <Modal.Body className="text-center">
              <div className="d-flex justify-content-center flex-wrap">
                {[...Array(9)].map((_, index) => {
                  const intensity = index + 1;
                  const colorCodes = [
                    "#B5E1BB",
                    "#87E196",
                    "#4DD364",
                    "#49B2DF",
                    "#5098D6",
                    "#236297",
                    "#FFA196",
                    "#DC5C51",
                    "#FE0012",
                    "#BF000B",
                  ];
                  return (
                    <div
                      key={intensity}
                      className="d-flex flex-column align-items-center mb-3"
                    >
                      <Button
                        className={`btn ${selectedIntensity === intensity
                          ? "btn-primary active"
                          : "btn-success"
                          }`}
                        onClick={() =>
                          handleSelectIntensity(
                            intensity,
                            showExercise?.exercise?.weight_scale == 0
                              ? precisionLift[index].weight_change
                              : heavyLift[index].weight_change
                          )
                        }
                        style={{
                          width: "70px",
                          height: "50px",
                          fontWeight: "500",
                          fontSize: "22px", // Increase font size
                          color: "#000",
                          backgroundColor: colorCodes[index],
                          borderStyle: selectedIntensity === intensity ? "solid" : "hidden",
                          borderColor: selectedIntensity === intensity ? "#FFD700" : "#000", // Gold border when active
                          borderWidth: selectedIntensity === intensity ? "3px" : "1px", // Thicker border when active
                          boxShadow: selectedIntensity === intensity ? "0 0 10px rgba(255, 215, 0, 0.8)" : "none", // Glow effect
                        }}
                      >
                        {intensity}
                      </Button>

                      <p
                        className="mt-2 text-center"
                        style={{
                          fontSize: "12px",
                          width: "90px",
                          wordWrap: "break-word",
                        }}
                      >
                        {showExercise?.exercise?.weight_scale == 0
                          ? precisionLift[index].difficulty
                          : heavyLift[index].difficulty}
                      </p>
                    </div>
                  );
                })}
              </div>

              <div className="text-center mt-4">
                <Button className="theme_btn1 mr-20" onClick={handleSubmit}>
                  Submit
                </Button>
              </div>
            </Modal.Body>
          </Modal>
          {isModalOpen && (
            <Modal
              show={isModalOpen}
              onHide={handleCloseExercise}
              id=""
              className="modal fade custom-modal-style muscles-modal"
              aria-hidden="true"
              aria-labelledby="exampleModalLabel"
              size="xl"
            >
              <Modal.Header>
                <h4>Exercise Details</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={handleCloseExercise}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </Modal.Header>
              <div className="container mt-3 mb-3">
                <div className="row mb-3">
                  <div className="col-9 col-md-7">
                    <h4 className="mb-20">
                      {showExercise.exerciseLevel
                        ? showExercise.exerciseLevel?.file_name
                        : ""}
                    </h4>
                  </div>
                  <div className="col-3 col-md-5 text-right">
                    <div className="btn-group">
                      <div className="icon_bar" onClick={handleClick}>
                        <svg
                          width="37"
                          height="37"
                          viewBox="0 0 37 37"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="18.1211"
                            cy="18.3081"
                            r="18"
                            fill="black"
                          ></circle>
                          <rect
                            x="10.9209"
                            y="18.6885"
                            width="3.32275"
                            height="9.53105"
                            fill={getEasy(showExercise.exerciseLevel.level_id)}
                          ></rect>
                          <rect
                            x="15.9927"
                            y="13.5295"
                            width="3.32275"
                            height="14.6901"
                            fill={getModerate(
                              showExercise.exerciseLevel.level_id
                            )}
                          ></rect>
                          <rect
                            x="21.4141"
                            y="8.10806"
                            width="3.32275"
                            height="20.1114"
                            fill={getAdvanced(
                              showExercise.exerciseLevel.level_id
                            )}
                          ></rect>
                        </svg>
                      </div>
                      <div
                        className={
                          isActive
                            ? "dropdown-menu dropdown-menu-right bar_dropdown show"
                            : "dropdown-menu dropdown-menu-right bar_dropdown"
                        }
                      >
                        <h4>Exercise Levels</h4>
                        <ul className="chart01">
                          <li>
                            <span></span>{" "}
                            <i>
                              <b>Level 1</b> Easy{" "}
                            </i>
                          </li>
                          <li>
                            <span></span>{" "}
                            <i>
                              <b>Level 2</b> Moderate{" "}
                            </i>
                          </li>
                          <li>
                            <span></span>{" "}
                            <i>
                              <b>Level 3</b> Advanced{" "}
                            </i>
                          </li>
                        </ul>
                        <div id="wrapper1">
                          <div className="btn_chart text-center">
                            <Link
                              to={`/program/change-level`}
                              state={{
                                exercise: showExercise,
                                activeDayId: activeDay,
                                programId: program.id,
                                redirectLink: "/assessment-timer",
                              }}
                              className="theme_btn1 small_btn"
                              onClick={() => handleActiveExercise(showExercise)}
                            >
                              Change Level
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {viewportWidth > 480 && (
                  <div>
                    {showExercise.exerciseLevel.starting_position && (
                      <>
                        <h6>Starting Position</h6>
                        <p>
                          <Interweave
                            content={showExercise.exerciseLevel.starting_position}
                          />
                        </p>
                      </>
                    )}

                    {showExercise.exerciseLevel.movements && (
                      <>
                        <h6>Movement</h6>
                        <p>
                          <Interweave
                            content={showExercise.exerciseLevel.movements}
                          />
                        </p>
                      </>
                    )}

                    {showExercise.exerciseLevel.notes && (
                      <div className="exc_p">
                        <p>
                          <span>Note:</span>
                          <Interweave
                            content={showExercise.exerciseLevel.notes}
                          />
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Modal>
          )}
          <Modal
            show={isEndExerciseConfirm}
            onHide={handleEndExerciseConfirm}
            id="end-exercise-confirm-modal"
            className="workout-modal"
            centered
            size="lg"
            backdrop="static"
          >
            <div className="modal-background p-4 text-center">
              <h4><strong>Set 1 of 3 complete!</strong></h4>
              <p className="mt-3">Would you like to repeat the circuit?</p>
              <div className="d-flex justify-content-center gap-3 mt-4">
                <Button variant="danger" className="custom-btn" onClick={handleRepeatCircuit}>
                  <div><strong>Yes</strong></div>
                  <small>Continue</small>
                </Button>
                <Button variant="dark" className="custom-btn" onClick={handleCompleteExercise}>
                  <div><strong>No</strong></div>
                  <small>End Workout</small>
                </Button>
              </div>
            </div>
          </Modal>
          <Modal
            show={isEndExercise}
            onHide={handleEndExercise}
            id=""
            className="modal fade workout-finished-modal custom-fullscreen-modal"
            size="xl"
          >
            <div className="modal-background text-white text-center p-5 position-relative">
              <button
                type="button"
                className="custom-close-btn position-absolute top-0 end-0 m-3"
                onClick={handleEndExercise}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" viewBox="0 0 16 16">
                  <path d="M2.146 2.146a.5.5 0 011 0L8 6.293l4.854-4.854a.5.5 0 11.707.707L8.707 7l4.854 4.854a.5.5 0 01-.707.707L8 7.707l-4.854 4.854a.5.5 0 01-.707-.707L7.293 7 2.146 2.854a.5.5 0 010-.707z" />
                </svg>
              </button>


              <div className="logo mb-4">
                <Link to="/home">
                  <img src={logo} alt="logo" className="img-fluid" />
                </Link>
              </div>
              <h2 className="fw-bold mt-5">WORKOUT</h2>
              <h2 className="fw-bold mt-1">FINISHED</h2>

            </div>
          </Modal>

        </section >
      </CommonPageData>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    exerciseUpdateRequest: state.programReducer.exerciseUpdateRequest || null,
    exerciseUpdateSuccess: state.programReducer.exerciseUpdateSuccess || null,
    exerciseUpdateFailure: state.programReducer.exerciseUpdateFailure || null,
    skipExerciseSuccess: state.testReducer.skipExerciseSuccess,
    skipTestReason: state.testReducer.skipTestReason,
  };
};
export default connect(mapStateToProps, {
  updateUserProgramDayExercise,
  getSkipReasons,
})(Test1Week1);
